import { useDeviceLinking } from '../../hooks/device/useDeviceLinking';
import DeviceLinkingHeader from './DeviceLinkingHeader';
import DeviceLinkingSkeleton from './DeviceLinkingSkeleton';
import DeviceLinkingMessages from './DeviceLinkingMessages';
import GenerateLinkCodeSection from './GenerateLinkCodeSection';
import EnterLinkCodeSection from './EnterLinkCodeSection';
import LinkedDevicesList from './LinkedDevicesList';

export default function DeviceLinking() {
  const {
    deviceId,
    linkCode,
    isGenerating,
    isLinking,
    linkCodeInput,
    linkedDeviceIds,
    error,
    success,
    copied,
    isUnlinking,
    isLoading,
    isAtLimit,
    handleGenerateCode,
    handleLinkDevices,
    handleCopyCode,
    handleUnlinkDevice,
    handleLinkCodeInputChange,
  } = useDeviceLinking();

  if (isLoading) {
    return <DeviceLinkingSkeleton />;
  }

  return (
    <div className="w-full max-w-2xl mx-auto p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm">
      <DeviceLinkingHeader deviceId={deviceId} />

      <DeviceLinkingMessages error={error} success={success} />

      <GenerateLinkCodeSection
        linkCode={linkCode}
        copied={copied}
        isGenerating={isGenerating}
        isAtLimit={isAtLimit}
        onGenerate={handleGenerateCode}
        onCopy={handleCopyCode}
      />

      <EnterLinkCodeSection
        linkCodeInput={linkCodeInput}
        isLinking={isLinking}
        isAtLimit={isAtLimit}
        onInputChange={handleLinkCodeInputChange}
        onLink={handleLinkDevices}
      />

      <LinkedDevicesList
        deviceIds={linkedDeviceIds}
        currentDeviceId={deviceId}
        isUnlinking={isUnlinking}
        onUnlink={handleUnlinkDevice}
      />
    </div>
  );
}
